<app-navbar [logoLink]="'/hospital/coordinator/dashboard'"></app-navbar>
@if (isLoading) {
  <div class="loading-spinner">
    <div class="spinner"></div>
    <p>Loading...</p>
  </div>
} @else {
  <div class="background">
    <div class="hospital-journey">
      <!-- Back to Dashboard Button -->
      <div class="back-button-container">
        <button class="back-btn" (click)="goBack()">
          ← Back to Donor Overview Dashboard
        </button>
      </div>

      <!-- Profile Section -->
      <div class="profile-header">
        <div class="profile-left">
          <div class="profile-picture">
            <img src="placeholder_profile.png" alt="Profile Picture" />
          </div>
          <div class="name-container">
            <p class="name">
              {{ profileInfo?.donor?.firstName }}
              {{ profileInfo?.donor?.lastName }}
            </p>
          </div>
        </div>
        <div class="contract-status-container">
          @if (downloadingConsent) {
            <span
              class="contract-status-pill"
              [ngClass]="getConsentStatusClass(this.contractStatus)"
            >
              <span class="spinner-border spinner-border-sm"></span>
              Downloading...
            </span>
          } @else {
            <span
              class="contract-status-pill"
              (click)="generateDownloadUrl()"
              [ngClass]="getConsentStatusClass(this.contractStatus)"
            >
              {{ this.contractStatus || "Consent Not Requested" }}
            </span>
          }
        </div>
      </div>

      <div>
        <app-tabs
          [tabs]="dashboardTabs"
          [defaultTab]="'Synopsis'"
          [tabBackgroundColor]="'#fff'"
          [routingStyle]="'path'"
          (tabChanged)="onTabChange($event)"
        ></app-tabs>
      </div>

      <router-outlet></router-outlet>
    </div>
  </div>
}
